<template>
  <div class="status-register-result">
    <PlatDataGridSite grid-id="PeStudentRegisterResult"
                      show-label>
      <template #append>
        <div class="custom-wrap">
          <el-divider direction="vertical"></el-divider>
          <StatusRegisterResultStatistics>
            <template #default="{toggleVisible}">
              <el-button size="mini"
                         type="primary"
                         icon="el-icon-pie-chart"
                         round
                         @click="toggleVisible">统计图表</el-button>
            </template>
          </StatusRegisterResultStatistics>
        </div>
      </template>
    </PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
import StatusRegisterResultStatistics from './statistics'
export default {
  name: 'StatusRegisterResult',
  components: {
    PlatDataGridSite,
    StatusRegisterResultStatistics
  }
}
</script>

<style lang="scss">
  .status-register-result {
    height: 100%;
    .custom-wrap {
      display: flex;
      align-items: center;
      .el-divider {
        margin-left: 15px;
        margin-right: 15px;
      }
    }
  }
</style>
